import { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export default {
    navBarMenu: {
        //Horizontal view
        '&.navbar-menu--horizontal': {
            alignItems: 'center',

            '.navbar-menu__item-divider': {
                opacity: 0.24,
                width: '1px',
                height: '16px',
                backgroundColor: (theme: Theme) => theme.componentSettings.topbar.textColor,
            },

            '.navbar-menu__root-item-holder': {
                position: 'relative',
                '&.navbar-menu__root-item-holder--active': {
                    filter: (theme: Theme) => `drop-shadow(0px 1px 4px ${alpha(theme.palette.text.primary, 0.32)})`,
                },
            },
            '.navbar-menu__root-item': {
                borderRadius: 1,
                userSelect: 'none',
                backgroundColor: 'transparent',
                padding: '0 12px',
                lineHeight: '26px',
                color: (theme: Theme) => theme.componentSettings.topbar.textColor,
                textDecoration: 'none',

                '&:hover .anim-pulsing': {
                    //turn of animation for hover user menu
                    animation: 'none',
                },
            },
            '.navbar-menu__root-item-holder.navbar-menu__root-item-holder--active .navbar-menu__root-item': {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                backgroundColor: 'background.default',
                color: 'primary.main',

                '.anim-pulsing': {
                    //turn of tooltip for active user menu
                    animation: 'none',
                    pointerEvents: 'none',
                },
            },
            '.navbar-menu__root-item-holder:not(.navbar-menu__root-item-holder--active) .navbar-menu__root-item:hover':
                {
                    cursor: 'pointer',
                    transition: (theme: Theme) => theme.transitions.create(['background-color']),
                    backgroundColor: (theme: Theme) => alpha(theme.componentSettings.topbar.textColor, 0.16),
                },
            '.navbar-menu__root-item-icon': {
                width: 16,
                height: 16,
                mr: 1,
                ml: -0.5,
                fontSize: '16px',
                flexShrink: 0,
                img: {
                    maxWidth: 1,
                    maxHeight: 1,
                },
                '&.avatar-icon': {
                    borderRadius: '100%',
                    overflow: 'hidden',
                },
            },
            '.navbar-menu__root-item-label--username': {
                whiteSpace: 'nowrap',
            },
            '.navbar-menu__root-item-component-icon': {
                '.MuiIconButton-root': {
                    borderRadius: 1,
                    py: '5px',
                    color: (theme: Theme) => theme.componentSettings.topbar.textColor,
                    '&:hover': {
                        backgroundColor: (theme: Theme) => alpha(theme.componentSettings.topbar.textColor, 0.16),
                        cursor: 'pointer',
                        transition: (theme: Theme) => theme.transitions.create(['background-color']),
                        color: (theme: Theme) => theme.componentSettings.topbar.textColor,
                    },
                    '&.active-state': {
                        pointerEvents: 'none',
                        backgroundColor: 'background.default',
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        color: 'primary.main',
                    },
                },
            },
        },

        //Vertical view
        '&.navbar-menu--vertical': {
            '.navbar-menu__item-divider': {
                opacity: 0.24,
                width: '100%',
                height: '1px',
                backgroundColor: (theme: Theme) => theme.componentSettings.leftbar.expandedTextColor,
            },
            '.navbar-menu__root-item-holder': {
                position: 'relative',
                '&.navbar-menu__root-item-holder--active': {
                    filter: (theme: Theme) => `drop-shadow(0px 4px 7px ${alpha(theme.palette.text.primary, 0.240636)})`,
                },
            },
            '.navbar-menu__root-item': {
                borderRadius: 1,
                userSelect: 'none',
                backgroundColor: 'transparent',
                padding: 0.5,
                lineHeight: '22px',
                textDecoration: 'none',
                color: (theme: Theme) => theme.componentSettings.leftbar.expandedTextColor,
            },
            '.navbar-menu__root-item-holder:not(.navbar-menu__root-item-holder--active) .navbar-menu__root-item:hover':
                {
                    cursor: 'pointer',
                    transition: (theme: Theme) => theme.transitions.create(['background-color']),
                    backgroundColor: (theme: Theme) => alpha(theme.componentSettings.leftbar.expandedTextColor, 0.04),
                },
            '.navbar-menu__root-item-holder.navbar-menu__root-item-holder--active .navbar-menu__root-item': {
                backgroundColor: (theme: Theme) => alpha(theme.componentSettings.leftbar.expandedTextColor, 0.08),
            },
            '.navbar-menu__root-item-icon': {
                width: 24,
                height: 22,
                mr: 0.5,
                fontSize: '16px',
                flexShrink: 0,
                img: {
                    maxWidth: 1,
                    maxHeight: 1,
                },
                '&.avatar-icon': {
                    borderRadius: '100%',
                    overflow: 'hidden',
                },
            },
            '.navbar-menu__root-item-label--username': {
                whiteSpace: 'nowrap',
            },
            '.navbar-menu__submenu': {
                left: '100%',
                bottom: 0,
            },
        },
    },

    submenuPopper: {
        zIndex: (theme: Theme) => theme.zIndex.appBar + 1,
        position: 'absolute',
        '&:not(.navbar-submenu-popper--active)': {
            position: 'absolute',
            inset: 'auto 100% 100% auto',
            visibility: 'hidden',
            pointerEvents: 'none',
        },

        '& > .navbar-submenu-popper__container': {
            backgroundColor: 'background.default',
            borderRadius: 1,
        },

        '&.navbar-submenu-popper--level-root': {},

        '&.navbar-submenu-popper--level-sub': {
            px: '4px !important',
            '& > .navbar-submenu-popper__container': {
                boxShadow: (theme: Theme) => `0px 1px 4px ${alpha(theme.palette.text.primary, 0.32)}`,
            },
        },

        '&.navbar-submenu-popper--view-horizontal': {
            '&.navbar-submenu-popper--level-root': {
                top: '100%',
                right: 0,

                '& > .navbar-submenu-popper__container': {
                    borderTopRightRadius: 0,
                },
            },
        },
        '&.navbar-submenu-popper--view-vertical': {
            '&.navbar-submenu-popper--level-root': {
                left: '100%',
                bottom: 0,
            },
        },
    },
    submenuItemHolder: {
        color: 'text.primary',
        py: 0.5,

        '.navbar-submenu__divider': {
            height: '1px',
            backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
            flexShrink: 0,
        },

        '.navbar-menu__root-item-holder > .navbar-submenu-popper & > .navbar-submenu__item-holder--hovered  > .navbar-submenu__item:not(:hover)':
            {
                backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
                color: 'primary.main',
                borderLeftColor: 'currentColor',
            },

        '.navbar-submenu__item-holder': {
            position: 'relative',
        },
        '.navbar-submenu__item': {
            padding: '5px 8px 5px 7px',
            borderLeft: '1px solid transparent',
            position: 'relative',
            flexDirection: 'row',
            textDecoration: 'none',
            color: 'inherit',
            '&:hover': {
                backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.8),
                color: 'background.default',
                cursor: 'pointer',
                textDecoration: 'none',
            },
        },
        '.navbar-submenu__item-icon': {
            width: 16,
            height: (theme: Theme) => theme.size.lineHeight * (theme.typography.topBarMenu.fontSize as number),
            mr: 1,
        },
        '.navbar-submenu__item-label': {
            flexGrow: 1,
            wordWrap: 'break-word',
            overflow: 'hidden',
        },
        '.navbar-submenu__item-children-ico': {
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: '16px',
        },
    },
};
